export default __webpack_public_path__ + "static/media/nfts.1944649f.jpg";